<template>
  <div data-app class="w-100 my-5">
    <div v-if="handlingFeeList && organizerList">
      <div class="box-white p-5 d-flex flex-column">
        <div class="row w-100 mt-5 vertical-center">
          <div class="col-sm-4 m-2 vertical-center pointer" @click="openOrganizerPage(organizerInfo.userId)" v-if="organizerInfo">
            <img class="circle-image-30" :src="organizerInfo.thumbnailUrl || organizerInfo.photoUrl || assets.profile" />
            <span class="ml-2 font-12 font-bold color-blue" v-if="organizerInfo">{{ organizerInfo.userName }}</span>
          </div>
          <div class="col-sm-4 m-2 vertical-center" v-else>
            <img class="circle-image-30" :src="assets.profile" />
          </div>
          <v-btn class="mx-5 button-normal" small @click="visibleOrganizerDialog = true">
            <span>{{ $t('select_organizer') }}</span>
          </v-btn>
        </div>
        <div class="row w-100 mt-5 vertical-center">
          <span class="col-sm-3 m-1 font-bold font-12 alpha-07">Ticket Percent (%)</span>
          <input class="col-sm m-1 font-12" v-model="ticketPercent" oninput="this.value = this.value.replace(/[^0-9.]/g, '');" />
        </div>
        <div class="row w-100 vertical-center">
          <span class="col-sm-3 mx-1 font-bold font-12 alpha-07">&nbsp;</span>
          <span class="col-sm m-1 font-12 color-red">Default Ticket Handling Fee Percent is {{ TICKET_HANDLING_FEE_PERCENT * 100 }}%.</span>
        </div>
        <div class="row w-100 mt-5 vertical-center">
          <span class="col-sm-3 m-1 font-bold font-12 alpha-07">Drink Percent (%)</span>
          <input class="col-sm m-1 font-12" v-model="drinkPercent" oninput="this.value = this.value.replace(/[^0-9.]/g, '');" />
        </div>
        <div class="row w-100 vertical-center">
          <span class="col-sm-3 mx-1 font-bold font-12 alpha-07">&nbsp;</span>
          <span class="col-sm m-1 font-12 color-red">Default Drink Handling Fee Percent is {{ DRINK_HANDLING_FEE_PERCENT * 100 }}%.</span>
        </div>
        <div class="my-5 d-flex justify-content-end">
          <v-btn class="mx-5 button-normal" small @click="setHandlingFeeTask" :disabled="!organizerInfo">
            <span>Save</span>
          </v-btn>
        </div>
      </div>
      <div class="row mx-auto mt-10 box-white">
        <div class="col-sm my-1 vertical-center">
          <span class="ml-5 font-bold font-15 alpha-07">Custom Handling Fee:</span>
          <span class="mx-5 font-bold font-20 color-blue">{{ handlingFeeList.length }}</span>
        </div>
        <div :class="`col-sm my-1 vertical-center ${isMobile ? '' : 'justify-content-end'}`">
          <input class="w-75" v-model="keyword" />
          <v-btn class="ml-2" icon small @click="keyword = ''" :disabled="!keyword">
            <i :class="`flaticon-circle ${keyword.length > 0 ? 'color-blue' : ''}`"></i>
          </v-btn>
        </div>
      </div>
      <div class="my-5" v-if="items.length > 0">
        <div class="mt-2" v-for="(item, index) in items" :key="(item, index)">
          <div class="m-1 box-white row vertical-center">
            <div class="col-sm-3 m-2 vertical-center pointer" @click="openOrganizerPage(item.organizerId)">
              <img class="circle-image-30" :src="item.photoUrl" />
              <div class="ml-2 d-flex flex-column">
                <span class="font-12 font-bold color-blue">{{ item.userName }}</span>
                <span class="mt-1 font-12" v-if="hostname === 'localhost'">ID: {{ item.organizerId }}</span>
                <span class="mt-1 font-12 color-red" v-if="item.organizerNote">{{ item.organizerNote }}</span>
              </div>
            </div>
            <div class="col-sm-3 m-2 vertical-center">
              <span class="font-12">Ticket:</span>
              <span :class="`ml-2 font-15 ${item.ticketPercent ? 'font-bold color-red' : 'color-primary'}`">{{ item.ticketPercent ? `${item.ticketPercent}%` : '--' }}</span>
            </div>
            <div class="col-sm-3 m-2 vertical-center">
              <span class="font-12">Drink:</span>
              <span :class="`ml-2 font-15 ${item.drinkPercent ? 'font-bold color-red' : 'color-primary'}`">{{ item.drinkPercent ? `${item.drinkPercent}%` : '--' }}</span>
            </div>
            <div class="col-sm m-2 vertical-center">
              <span class="font-12">{{ getDateStringFromTimestamp(item.updatedAt) }}</span>
              <v-btn class="ml-auto" icon small @click="deleteHandlingFeeTask(item.organizerId)">
                <i class="flaticon-delete color-red"></i>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="py-40 center" v-else>
        <span class="font-20 alpha-07">{{ $t('no_data_found') }}</span>
      </div>
    </div>
    <div class="py-40 center" v-else>
      <p>{{ $t('please_wait') }}</p>
      <b-spinner type="grow"></b-spinner>
    </div>
    <!-- Start Select Organizer Dialog -->
    <v-dialog v-model="visibleOrganizerDialog" scrollable width="800px">
      <v-card>
        <v-card-title class="d-flex flex-column">
          <div class="w-100 d-flex justify-content-between">
            <span class="font-bold font-18">{{ $t('select_organizer') }}</span>
            <v-btn class="ml-auto" icon small @click="visibleOrganizerDialog = false; organizerKeyword = '';">
              <i class="flaticon-cancel font-bold font-25 color-black"></i>
            </v-btn>
          </div>
          <div class="w-100 my-1 vertical-center">
            <input class="w-100" v-model="organizerKeyword" />
            <v-btn class="ml-2" icon small @click="organizerKeyword = ''" :disabled="!organizerKeyword">
              <i :class="`flaticon-circle ${organizerKeyword.length > 0 ? 'color-blue' : ''}`"></i>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text v-if="organizerList">
          <div class="m-2 box-white pointer vertical-center d-flex" v-for="(item, index) in organizerList.filter(element => element.userName.toLowerCase().includes(organizerKeyword.toLowerCase()))" :key="index" @click="onSelectOrganizer(item)">
            <img class="circle-image-30" :src="item.thumbnailUrl || item.photoUrl" />
            <span :class="`ml-5 font-bold ${isMobile ? 'font-12' : 'font-15'}`"> {{ item.userName }}</span>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End Select Organizer Dialog -->
  </div>
</template>

<script>
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../main';
import { getDateStringFromTimestamp, showLoading } from '../../../functions';

import profile from '@/assets/image/profile.jpg';

export default {
  name: 'SetHandlingFee',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    organizerList() {
      return this.$store.state.organizerList;
    },
    handlingFeeList() {
      return this.$store.state.handlingFeeList;
    }
  },
  watch: {
    organizerList(newList, oldList) {
      const oldCount = oldList ? oldList.length : 0;
      const newCount = newList ? newList.length : 0;
      if (oldCount !== newCount) {
        this.refreshData();
      }
    },
    handlingFeeList() {
      this.refreshData();
    },
    keyword() {
      this.refreshData();
    }
  },
  data() {
    return {
      assets: {
        profile
      },
      hostname: window.location.hostname,
      visibleOrganizerDialog: false,
      organizerKeyword: '',
      keyword: '',
      organizerInfo: null,
      ticketPercent: '',
      drinkPercent: '',
      items: []
    }
  },
  mounted() {
    this.initialize();
    this.refreshData();
  },
  methods: {
    getDateStringFromTimestamp,
    initialize() {
      this.organizerInfo = null;
      this.ticketPercent = '';
      this.drinkPercent = '';
    },
    onSelectOrganizer(item) {
      this.organizerInfo = item;
      this.visibleOrganizerDialog = false;
      this.organizerKeyword = '';
      if (this.handlingFeeList) {
        const handlingFeeInfo = this.handlingFeeList.find(element => element.organizerId === item.userId);
        if (handlingFeeInfo) {
          this.ticketPercent = handlingFeeInfo.ticketPercent;
          this.drinkPercent = handlingFeeInfo.drinkPercent;
        }
      }
    },
    openOrganizerPage(organizerId) {
      window.open(`${window.location.origin}/users/1/${organizerId}`, '_blank');
    },
    refreshData() {
      const items = [];
      const keyword = this.keyword.toLowerCase();
      if (this.handlingFeeList && this.organizerList) {
        this.handlingFeeList.forEach(info => {
          const organizerInfo = this.organizerList.find(element => element.userId === info.organizerId);
          if (organizerInfo && organizerInfo.userName.toLowerCase().includes(keyword)) {
            info['userName'] = organizerInfo.userName;
            info['photoUrl'] = organizerInfo.thumbnailUrl || organizerInfo.photoUrl || this.assets.profile;
            if (organizerInfo.deletedAt) {
              info['organizerNote'] = `Deleted at: ${getDateStringFromTimestamp(organizerInfo.deletedAt)}`;
            } else if (organizerInfo.blockedAt) {
              info['organizerNote'] = `Blocked at: ${getDateStringFromTimestamp(organizerInfo.blockedAt)}`;
            }
            items.push(info);
          }
        });
        items.sort((a, b) => (a.updatedAt.seconds < b.updatedAt.seconds) ? 1 : -1);
      }
      this.items = items;
    },
    setHandlingFeeTask() {
      if (!this.organizerInfo) {
        this.$toast.info('Please select an Organizer.');
        return;
      }
      if (!this.ticketPercent && !this.drinkPercent) {
        this.$toast.info('Please enter Handling Fee Percent.');
        return;
      }

      let message;
      if (this.ticketPercent && !this.drinkPercent) {
        message = `Are you sure you want to set Ticket Handling Fee as ${this.ticketPercent}% for '${this.organizerInfo.userName}'?`;
      } else if (!this.ticketPercent && this.drinkPercent) {
        message = `Are you sure you want to set Drink Handling Fee as ${this.drinkPercent}% for '${this.organizerInfo.userName}'?`;
      } else {
        message = `Are you sure you want to set Ticket Handling Fee as ${this.ticketPercent}%, Drink Handling Fee as ${this.drinkPercent}% for '${this.organizerInfo.userName}'?`;
      }
      if (!confirm(message)) {
        return;
      }
      const params = {
        functionName: 'setHandlingFee',
        organizerId: this.organizerInfo.userId,
        ticketPercent: this.ticketPercent,
        drinkPercent: this.drinkPercent
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
          this.initialize();
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    },
    deleteHandlingFeeTask(organizerId) {
      if (!organizerId) {
        this.$toast.error('Unexpected error occurs.');
        return;
      }
      if (!confirm('Are you sure you want to delete?')) {
        return;
      }
      const params = {
        functionName: 'setHandlingFee',
        isDelete: true,
        organizerId: organizerId
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    }
  }
};
</script>